import React from 'react'

import { useNotification } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'

export type NotificationBellProps = {
  onClick?: () => void
}

export const NotificationBell = ({ onClick }: NotificationBellProps) => {
  const { unreadCount } = useNotification({})

  return (
    <div className="position-relative d-inline-block">
      <div className="px-2">
        <BusyButtonLink variant="link" icon="bell" onClick={onClick}>
          {unreadCount > 0 && (
            <span className="position-absolute translate-middle badge rounded-pill bg-danger">{unreadCount}</span>
          )}
        </BusyButtonLink>
      </div>
    </div>
  )
}
